module.exports = __webpack_public_path__ + "images/emoji/dancer.1faa2028d801c8bfda62.png";